import { useState, useCallback } from "react";
export function useInput(init) {
    const [_input, setInput] = useState(init.initialInput || {});
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errored, setErrored] = useState(false);
    const [error, setError] = useState(undefined);
    const submit = useCallback(async (input) => {
        setSubmitting(true);
        const dataToSend = input || _input;
        try {
            const response = await fetch(init.url, {
                ...init,
                method: init.method || "POST",
                headers: {
                    ...init.headers,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataToSend),
            });
            if (!response.status.toString().startsWith("2")) {
                throw new Error(response.statusText);
            }
            setSuccess(true);
            setErrored(false);
            setError(undefined);
            if (typeof init.onSuccess === "function") {
                init.onSuccess(response, dataToSend);
            }
        }
        catch (error) {
            setSuccess(false);
            setErrored(true);
            setError(error);
            console.error(error);
            if (typeof init.onError === "function") {
                init.onError(error, dataToSend);
            }
        }
        finally {
            setSubmitting(false);
        }
    }, [_input, init]);
    const setField = useCallback((name, value) => {
        setInput((input) => ({ ...input, [name]: value }));
    }, []);
    const setInputHandler = useCallback((input, opts) => {
        setInput(input);
        if (opts?.submitOnSet) {
            submit(input);
        }
    }, [submit]);
    return {
        input: _input,
        submitting,
        success,
        errored,
        error,
        setField,
        setInput: setInputHandler,
        submit,
    };
}
